import React from 'react';
import classNames from 'classnames';
import { SIZES } from './constants';
function ColorCircle({ color = '', secondColor = '', opacity = 1, size = SIZES.medium }) {
  const hasSecondColor = Boolean(secondColor);
  const hasColor = Boolean(color || secondColor);

  const classes = classNames('ws-ui-color-circle', `ws-ui-color-circle--${size}`, {
    'ws-ui-color-circle--not-provided': !hasColor,
    'ws-ui-color-circle--one-color': hasColor && !hasSecondColor,
    'ws-ui-color-circle--two-colors': hasSecondColor,
  });

  return (
    <div
      className={classes}
      style={{
        '--color': color || secondColor,
        '--second-color': secondColor || color,
        '--opacity': opacity,
      }}
    />
  );
}

export default ColorCircle;
